// Barber Types
export interface Barber {
    id: number;
    userId: number;
    firstName: string;
    lastName: string;
    nickname: string;
    email: string;
    specialization?: string;
    yearsOfExperience?: number;
    pricePerService?: number;
    address?: string;
    whatsapp?: string;
    instagramUrl?: string;
    facebookUrl?: string;
    profilePicture?: string;
    status: BarberStatus;
    approvedBy?: number;
    approvedAt?: string;
    createdAt: string;
    schedules?: BarberSchedule[];
    services?: BarberOfferedService[];
    isIndependent?: boolean;
}

export enum BarberStatus {
    PENDING_APPROVAL = 'PENDING_APPROVAL',
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
    SUSPENDED = 'SUSPENDED'
}

export interface BarberSchedule {
    id?: number;
    barberId?: number;
    dayOfWeek: DayOfWeek;
    startTime: string;
    endTime: string;
    branchId?: number;      // Now each schedule has its own branch
    branchName?: string;
    isAvailable: boolean;
}

export enum DayOfWeek {
    MONDAY = 'MONDAY',
    TUESDAY = 'TUESDAY',
    WEDNESDAY = 'WEDNESDAY',
    THURSDAY = 'THURSDAY',
    FRIDAY = 'FRIDAY',
    SATURDAY = 'SATURDAY',
    SUNDAY = 'SUNDAY'
}

export interface ServiceType {
    id: number;
    name: string;
    description: string;
    suggestedPrice: number;
    defaultDurationMinutes: number;
    allowParallel: boolean;
}

export interface BarberOfferedService {
    id: number;
    serviceTypeId: number;
    name: string;
    price: number;
    durationMinutes: number;
    isCustomPrice: boolean;
}

export interface BarberRegistrationRequest {
    nickname: string;
    specialization: string;
    yearsOfExperience: number;
    preferredBranchId?: number;
}

export interface BarberApprovalRequest {
    barberId: number;
    pricePerService: number; // Deprecated
    schedules: ScheduleRequest[];
    services: BarberServiceRequest[];
}

export interface BarberServiceRequest {
    serviceTypeId: number;
    customPrice?: number;
    customDurationMinutes?: number;
}

export interface ScheduleRequest {
    dayOfWeek: string;
    startTime: string;
    endTime: string;
    branchId: number;  // Branch assigned per schedule day
}

export interface ProfileUpdateRequest {
    address?: string;
    whatsapp?: string;
    instagramUrl?: string;
    facebookUrl?: string;
    profilePictureUrl?: string;
    isIndependent?: boolean;
}

export interface PasswordChangeRequest {
    currentPassword: string;
    newPassword: string;
}

export interface BarberCreationRequest {
    email: string;
    firstName: string;
    lastName: string;
    nickname: string;
    phoneNumber?: string;
    instagramUrl?: string;
    facebookUrl?: string;
    profilePictureUrl?: string;
    role: 'BARBER' | 'SUPERUSER';
    specialization: string;
    yearsOfExperience: number;
    pricePerService: number; // Deprecated
    schedules: ScheduleRequest[];
    services: BarberServiceRequest[];
    isIndependent?: boolean;
}

export interface BarberCreationResponse extends Barber { }
